import { SdDeepLinkAction } from '@varo/graphql-schema-types';
import { useCallback } from 'react';
import { parseGQLAnalyticsEvent } from 'services/analytics/helpers/parseGQLAnalyticsEvent';
import { segmentClient } from 'services/analytics/segment/segment';
import { openExternalUrl } from 'services/deeplinks/helpers/openExternalUrl';

export const useDebtSaleAction = () => {
  const handleDebtSaleAction = useCallback(
    async (action: SdDeepLinkAction): Promise<void> => {
      if (action.analyticsEvent) {
        const { name, properties } = parseGQLAnalyticsEvent(
          action.analyticsEvent,
        );
        void segmentClient.logEvent(name, properties);
      }

      await openExternalUrl(action.deeplink);
    },
    [],
  );

  return { handleDebtSaleAction };
};
